import { Tooltip } from "antd";
import { FormattedMessage } from "react-intl";
import type { UserPermissionTransformed } from "~pages/Users/types";
import type { LabelValue } from "~types/labelValue";

type Props = {
  userPermission: UserPermissionTransformed;
  value: LabelValue[] | null;
};

const UserPermissionScopeValueLabel = ({ userPermission, value }: Props) => {
  if (!userPermission?.scope) {
    return <FormattedMessage id="all" />;
  }

  if (!value) {
    return <span>—</span>;
  }

  const valueStr = value.map(({ label }) => label).join(", ");

  return (
    <Tooltip placement="topLeft" title={valueStr}>
      {valueStr}
    </Tooltip>
  );
};

export default UserPermissionScopeValueLabel;
